import {defineStore} from "pinia";
import {Duplicacion} from "@/models/Duplicacion";
import moment from "moment";

export const duplicacionStore = defineStore("duplicacionStore", {
    state: () =>
        ({
            loading: false as boolean,
            duplicaciones: [] as Duplicacion[],
            duplicacion: new Duplicacion() as Duplicacion,

            motivos: [] as any[],

            isNewOtroIngreso: false as boolean,
            isNewConsumoAgua: false as boolean,
            fechaHora: moment().format('YYYY-MM-DDTHH:mm:ss') as string,
        }),
});